import { useEffect } from "react";
import { AppToasterV2, CoreFieldValue, MultiStepItemProps } from "@ucl/library";
import { PersonalAccountBeneficiaries } from "./PersonalAccountBeneficiaries";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { useFinancialApplicationFormSectionValidation, FinancialApplicationFormSectionContextType } from "@/hooks/useFinancialApplicationFormSectionValidation";
import { FinancialApplicationSection } from "@/types/enums";

export interface PersonalAccountBeneficiariesStepProps extends MultiStepItemProps {
  financialApplicationId: string;
  onBlur?: (field: CoreFieldValue) => void;
  initiallyCollapsePersonalAccountBeneficiaryForms?: boolean;
  readOnly?: boolean;
  renderCollapsedAsTable?: boolean;
}

export const PersonalAccountBeneficiariesStep: React.FC<PersonalAccountBeneficiariesStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <PersonalAccountBeneficiariesStepInner {...props} />
    </RequireAuth>
  );
};

const PersonalAccountBeneficiariesStepInner: React.FC<PersonalAccountBeneficiariesStepProps> = (props) => {
  const { validateFinancialApplicationFormSection } = useFinancialApplicationFormSectionValidation(
    props.financialApplicationId, 
    FinancialApplicationSection.PersonalAccountBeneficiaries
  );

  useEffect(() => {
    props.registerSubmit?.(async () => {
      const { isValid } = await validateFinancialApplicationFormSection();

      if (!isValid) {
        AppToasterV2.showFailedActionToaster(
          "Please correct the highlighted fields to proceed.",
          "Action Required"
        );
      }
      return isValid;
    });
  }, [props.financialApplicationId, validateFinancialApplicationFormSection]);

  return (
    <section className="personal-account-beneficiary-info step-section">
      <div className="personal-account-beneficiary-info__header step-header">
        Beneficiary Information
      </div>
      <div className="personal-account-beneficiary-info__subtitle step-subtitle">
        Please provide beneficiary information for designation purposes.
      </div>
      <div className="personal-account-beneficiary-info-form__content step-content">
        <PersonalAccountBeneficiaries
          financialApplicationId={props.financialApplicationId}
          onBlur={props.onBlur}
          initiallyCollapsePersonalAccountBeneficiaryForms={props.initiallyCollapsePersonalAccountBeneficiaryForms}
          readOnly={props.readOnly}
          renderCollapsedAsTable={props.renderCollapsedAsTable}
          validationContextType={FinancialApplicationFormSectionContextType.Applicant}
        />
      </div>
    </section>
  );
}; 